import KakaoAddressSearch from '../../components/KakaoAddressSearch';
import AuthService from '../../api/service/auth/AuthService';
import SelectBox from '../../components/SelectBox';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { formatPhoneNumber } from '../../utils/formatPhoneNumber';
import { useNavigate } from 'react-router-dom';
import { MyPageUrl } from '../../url/poenUrl';
import { formatBusinessNumber } from '../../utils/formatBusinessNumber';
import { formatAccountNumber } from '../../utils/formatAccountNumber';
import AccountService from '../../api/service/member/AccountService';
import FindPasswordPopup from './FindPasswordPopup';

const Container = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.whiteColor};
`;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 20px 10px 10px 10px;
  max-width: 1024px;
  margin: 0 auto;
  border-radius: 10px;
  @media (max-width: 768px) {
    gap: 15px;
    padding-top: 0px;
  }
`;

const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const SectionTitleContainer = styled.div`
  margin: 10px 0px;
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
`;

const Line = styled.div`
  flex: 1;
  height: 1px;
  background-color: #ddd;
`;

const StyledSectionTitle = styled.h2`
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  color: #333;
`;

const RowContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const RowBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  @media (max-width: 768px) {
    gap: 10px;
  }
`;
const Row = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px;
  @media (max-width: 768px) {
    gap: 10px;
  }
`;

const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
  width: 150px;
  text-align: left;
  @media (max-width: 768px) {
    width: 100%;
    text-align: left;
  }
`;

const LabelNo = styled.label`
  width: 150px;

  @media (max-width: 768px) {
    display: none;
  }
`;
const LabelSecond = styled(Label)`
  width: 70px;
  @media (max-width: 768px) {
    width: 100%;
    text-align: left;
  }
`;

const Text = styled.div`
  flex: 1;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  max-width: 300px;
  @media (max-width: 768px) {
    max-width: 600px;
    min-width: 200px;
    width: 100%;
  }
`;

const Input = styled.input`
  flex: 1;
  padding: 10px;
  max-width: 300px;

  border: 1px solid ${({ theme }) => theme.colors.inputLine};
  background-color: ${({ theme }) => theme.colors.inputBG};
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.mainColor};
  }
  @media (max-width: 768px) {
    max-width: 600px;
    min-width: 200px;
    width: 100%;
  }
`;

const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  gap: 20px;
`;

const Button = styled.button`
  padding: 5px 10px;
  background-color: #aca7a4;
  color: white;
  font-size: 14px;
  border: none;
  border-radius: 4px;
  cursor: pointer;

  &:hover {
    background-color: #9a9694;
  }
`;

const UpdateButton = styled(Button)`
  flex: 1;
  padding: 10px 16px;
  background-color: ${({ theme }) => theme.colors.subColor};
  &:hover {
    background-color: ${({ theme }) => theme.colors.subHoverColor};
  }
`;

const SecessionButton = styled(Button)`
  flex: 1;
  padding: 10px 16px;
  border: 1px solid ${({ theme }) => theme.colors.subColor};
  background-color: ${({ theme }) => theme.colors.whiteColor};
  color: ${({ theme }) => theme.colors.textColor};

  &:hover {
    border: 1px solid ${({ theme }) => theme.colors.subHoverColor};
    background-color: ${({ theme }) => theme.colors.whiteColor};
    color: ${({ theme }) => theme.colors.textColor};
  }
`;

const ButtonM = styled(Button)`
  display: none;
  @media (max-width: 768px) {
    display: block;
  }
`;
const ButtonP = styled(Button)`
  display: block;
  @media (max-width: 768px) {
    display: none;
  }
`;

const MyPageTab2 = () => {
  const navigate = useNavigate();
  const [permissions, setPermissions] = useState('');

  const [formData, setFormData] = useState({
    identifier: '',
    email: '',
    emailCode: '',
    phoneNumber: '',
    name: '',
    zipCode: '',
    defaultAddress: '',
    detailAddress: '',
    businessNumber: '',
    businessRepresentativeName: '',
    businessOpenDate: '',
    businessName: '',
    businessZipCode: '',
    businessDefaultAddress: '',
    businessDetailAddress: '',
    businessAccountBank: '',
    businessAccountNumber: '',
  });

  const [bank, setBank] = useState(''); // 추가한 은행 선택 상태

  const [bankOptions, setBankOptions] = useState<
    { value: string; label: string }[]
  >([]);

  const [isValidated, setIsValidated] = useState(false); // 사업자 확인 여부
  const [originalBusinessData, setOriginalBusinessData] = useState({
    businessNumber: '',
    businessRepresentativeName: '',
    businessOpenDate: '',
  });

  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const handleOpenPopup = () => {
    //console.log('열려라!!');
    setIsPopupOpen(true);
  };
  const handleClosePopup = () => {
    //console.log('닫힘!!');
    setIsPopupOpen(false);
  };

  useEffect(() => {
    const fetchPermissions = () => {
      const storedPermissions = localStorage.getItem('permissions') || 'BUYER'; // 기본값: BUYER
      setPermissions(storedPermissions);
      //console.log(storedPermissions);
    };
    fetchPermissions();
  }, []);

  useEffect(() => {
    fetchMemberAccount();
  }, []);

  const fetchMemberAccount = async () => {
    try {
      const response = await AccountService.getMemberAccount();
      const data = response.data;

      setOriginalBusinessData({
        businessNumber: formatBusinessNumber(
          data.businessInfo?.businessNumber || ''
        ),
        businessRepresentativeName:
          data.businessInfo?.businessRepresentativeName || '',
        businessOpenDate: data.businessInfo?.businessOpenDate || '',
      });

      setFormData({
        identifier: data.identifier || '',
        email: data.email || '',
        emailCode: '',
        phoneNumber: formatPhoneNumber(data.phoneNumber || ''), // 여기서 포맷 적용
        name: data.name || '',
        zipCode: data.address?.zipCode || '',
        defaultAddress: data.address?.defaultAddress || '',
        detailAddress: data.address?.detailAddress || '',
        businessNumber: formatBusinessNumber(
          data.businessInfo?.businessNumber || ''
        ),
        businessRepresentativeName:
          data.businessInfo?.businessRepresentativeName || '',
        businessOpenDate: data.businessInfo?.businessOpenDate || '',
        businessName: data.businessInfo?.businessName || '',
        businessZipCode: data.businessInfo?.businessAddress?.zipCode || '',
        businessDefaultAddress:
          data.businessInfo?.businessAddress?.defaultAddress || '',
        businessDetailAddress:
          data.businessInfo?.businessAddress?.detailAddress || '',
        businessAccountBank:
          data.businessInfo?.businessAccount?.accountBank || '',
        businessAccountNumber: formatAccountNumber(
          data.businessInfo?.businessAccount?.accountNumber || ''
        ),
      });

      setBank(data.businessInfo?.businessAccount?.accountBank || ''); // 초기값 설정
    } catch (error) {
      console.error('회원 정보 조회 실패:', error);
      alert('회원 정보를 불러오는 중 오류가 발생했습니다.');
    }
  };

  // 데이터 변경 여부 확인
  useEffect(() => {
    const hasBusinessDataChanged =
      formData.businessNumber !== originalBusinessData.businessNumber ||
      formData.businessRepresentativeName !==
        originalBusinessData.businessRepresentativeName ||
      formData.businessOpenDate !== originalBusinessData.businessOpenDate;

    setIsValidated(!hasBusinessDataChanged); // 데이터 변경 시 사업자 확인 필요
  }, [
    formData.businessNumber,
    formData.businessRepresentativeName,
    formData.businessOpenDate,
  ]);

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // 사용자 주소 onComplete 콜백 함수
  const handleAddressComplete = (address: string, zipCode: string) => {
    setFormData((prev) => ({
      ...prev,
      zipCode: zipCode,
      defaultAddress: address,
    }));
  };

  // 판매자 사업장 주소
  const handleSellerAddressComplete = (address: string, zipCode: string) => {
    setFormData((prev) => ({
      ...prev,
      businessZipCode: zipCode,
      businessDefaultAddress: address,
    }));
  };

  //회원가입 로직
  const handleUpdateAccount = async () => {
    try {
      // 전화번호에서 '-' 제거
      const cleanedPhoneNumber = formData.phoneNumber.replace(/-/g, '');
      const cleanedBusinessNumber = formData.businessNumber.replace(/-/g, '');
      const cleanedBusinessAccountNumber =
        formData.businessAccountNumber.replace(/-/g, '');

      // 필수 값 검증
      const requiredFields = [
        { field: formData.phoneNumber, message: '전화번호를 입력해주세요.' },
        { field: formData.zipCode, message: '우편번호를 입력해주세요.' },
        { field: formData.defaultAddress, message: '주소를 입력해주세요.' },
      ];

      if (permissions === 'SELLER') {
        requiredFields.push(
          {
            field: formData.businessNumber,
            message: '사업자등록번호를 입력해주세요.',
          },
          {
            field: formData.businessRepresentativeName,
            message: '대표자 이름을 입력해주세요.',
          },
          {
            field: formData.businessOpenDate,
            message: '개업일자를 입력해주세요.',
          },
          { field: formData.businessName, message: '사업장명을 입력해주세요.' },
          {
            field: formData.businessZipCode,
            message: '사업장 우편번호를 입력해주세요.',
          },
          {
            field: formData.businessDefaultAddress,
            message: '사업장 주소를 입력해주세요.',
          },
          { field: bank, message: '은행을 선택해주세요.' },
          {
            field: formData.businessAccountNumber,
            message: '계좌번호를 입력해주세요.',
          }
        );
      }

      if (!isValidated) {
        alert(
          '사업자 정보가 변경되었습니다. 확인 버튼을 눌러 사업자 정보를 확인해주세요.'
        );
        return;
      }

      for (const { field, message } of requiredFields) {
        if (!field || field.trim() === '') {
          alert(message);
          return;
        }
      }

      if (permissions === 'BUYER') {
        const buyerData = {
          phoneNumber: cleanedPhoneNumber,
          zipCode: formData.zipCode,
          defaultAddress: formData.defaultAddress,
          detailAddress: formData.detailAddress, // 선택 값
        };

        await AccountService.updateBuyerAccount(buyerData);
        alert('구매자 정보 수정이 완료되었습니다.');
      } else if (permissions === 'SELLER') {
        const sellerData = {
          phoneNumber: cleanedPhoneNumber,
          zipCode: formData.zipCode,
          defaultAddress: formData.defaultAddress,
          detailAddress: formData.detailAddress, // 선택 값
          businessNumber: cleanedBusinessNumber,
          businessRepresentativeName: formData.businessRepresentativeName,
          businessOpenDate: formData.businessOpenDate,
          businessName: formData.businessName,
          businessZipCode: formData.businessZipCode,
          businessDefaultAddress: formData.businessDefaultAddress,
          businessDetailAddress: formData.businessDetailAddress, // 선택 값
          businessAccountBank: bank,
          businessAccountNumber: cleanedBusinessAccountNumber,
        };

        await AccountService.updateSellerAccount(sellerData);
        alert('판매자 정보 수정이 완료되었습니다.');
      }
      fetchMemberAccount();
    } catch (error) {
      console.error('회원가입 실패:', error);
      alert(error);
    }
  };

  const handleSellerValidate = async () => {
    try {
      const { businessNumber, businessRepresentativeName, businessOpenDate } =
        formData;

      // 필수값 체크
      if (!businessNumber || !businessRepresentativeName || !businessOpenDate) {
        // console.log(
        //   businessNumber,
        //   businessRepresentativeName,
        //   businessOpenDate
        // );

        alert('사업자등록번호와 대표자 성명, 개업일자를 입력해주세요.');
        return;
      }

      const cleanedBusinessNumber = businessNumber.replace(/-/g, '');

      const validateData = {
        businessNumber: cleanedBusinessNumber,
        businessRepresentativeName: businessRepresentativeName,
        businessOpenDate: businessOpenDate,
      };

      await AuthService.sellerBusinessValidate(validateData);
      setIsValidated(true); // 확인 성공 시 상태 업데이트
      alert(`사업자 등록번호 확인 성공`);
    } catch (error) {
      console.error('사업자 등록번호 확인 실패:', error);
      alert(error);
    }
  };

  // 은행 목록 가져오기
  useEffect(() => {
    const fetchBankOptions = async () => {
      try {
        const response = await AuthService.getSellerBusinessBanks();
        const banks = response.data.map((bankName: string) => ({
          value: bankName,
          label: bankName,
        }));
        setBankOptions(banks); // 상태에 은행 목록 저장
      } catch (error) {
        console.error('은행 목록 조회 실패:', error);
      }
    };

    fetchBankOptions();
  }, []);

  return (
    <Container>
      <Box>
        {permissions === 'SELLER' ? (
          <>
            <Section>
              <Row>
                <Label>아이디</Label>
                <Text>{formData.identifier}</Text>
              </Row>
              <Row>
                <Label>비밀번호</Label>
                <Button type="button" onClick={handleOpenPopup}>
                  비밀번호 변경
                </Button>
              </Row>
              <Row>
                <Label>이름</Label>
                <Text>{formData.name}</Text>
              </Row>

              <Row>
                <Label>이메일주소</Label>
                <Text>{formData.email}</Text>
              </Row>

              <Row>
                <Label>전화번호</Label>
                <Input
                  type="text"
                  placeholder="전화번호를 입력해주세요"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={(e) => {
                    const formattedNumber = formatPhoneNumber(e.target.value); // 3-4-4 포맷 적용
                    setFormData((prevData) => ({
                      ...prevData,
                      phoneNumber: formattedNumber,
                    }));
                  }}
                />
              </Row>

              <Row>
                <Label>주소</Label>
                <Input
                  type="text"
                  placeholder="주소를 입력해주세요"
                  name="defaultAddress"
                  value={formData.defaultAddress}
                  readOnly
                />
                <KakaoAddressSearch onComplete={handleAddressComplete} />
              </Row>
              <Row>
                <LabelNo />
                <Input
                  type="text"
                  placeholder="우편번호"
                  style={{ maxWidth: 100 }}
                  readOnly
                  name="zipCode"
                  value={formData.zipCode}
                />
                <Input
                  type="text"
                  placeholder="상세 주소를 입력해주세요"
                  name="detailAddress"
                  value={formData.detailAddress}
                  onChange={handleChange}
                />
              </Row>
            </Section>
            <Section>
              <SectionTitleContainer>
                <Line />
                <StyledSectionTitle>진단정보(판매자)만 입력</StyledSectionTitle>
                <Line />
              </SectionTitleContainer>
              <RowContainer>
                <RowBox>
                  <Row>
                    <Label>사업자등록번호</Label>
                    <Input
                      type="text"
                      placeholder="사업자등록번호를 입력해주세요"
                      name="businessNumber"
                      value={formData.businessNumber}
                      onChange={(e) => {
                        const formattedNumber = formatBusinessNumber(
                          e.target.value
                        );
                        setFormData((prevData) => ({
                          ...prevData,
                          businessNumber: formattedNumber,
                        }));
                      }}
                    />
                    <LabelSecond>대표자 성명</LabelSecond>
                    <Input
                      type="text"
                      placeholder="대표자 성명을 입력해주세요"
                      name="businessRepresentativeName"
                      value={formData.businessRepresentativeName}
                      onChange={handleChange}
                    />
                  </Row>
                  <Row>
                    <Label>사업장명</Label>
                    <Input
                      type="text"
                      placeholder="사업장명을 입력해주세요"
                      name="businessName"
                      value={formData.businessName}
                      onChange={handleChange}
                    />
                    <LabelSecond>개업일자</LabelSecond>
                    <Input
                      type="date"
                      placeholder="개업일자를 입력해주세요"
                      name="businessOpenDate"
                      value={formData.businessOpenDate}
                      onChange={handleChange}
                    />
                    <ButtonM type="button" onClick={handleSellerValidate}>
                      사업자 확인
                    </ButtonM>
                  </Row>
                </RowBox>
                <ButtonP type="button" onClick={handleSellerValidate}>
                  사업자 확인
                </ButtonP>
              </RowContainer>
              <Row>
                <Label>사업장 주소</Label>
                <Input
                  type="text"
                  placeholder="주소를 입력해주세요"
                  name="businessDefaultAddress"
                  value={formData.businessDefaultAddress}
                  readOnly
                />
                <KakaoAddressSearch onComplete={handleSellerAddressComplete} />
              </Row>
              <Row>
                <LabelNo />
                <Input
                  type="text"
                  placeholder="우편번호"
                  style={{ maxWidth: 100 }}
                  readOnly
                  name="businessZipCode"
                  value={formData.businessZipCode}
                />
                <Input
                  type="text"
                  placeholder="상세 주소를 입력해주세요"
                  name="businessDetailAddress"
                  value={formData.businessDetailAddress}
                  onChange={handleChange}
                />
              </Row>
              <Row>
                <Label>계좌번호</Label>
                <SelectBox
                  options={bankOptions}
                  value={bank}
                  onChange={setBank}
                  placeholder="은행을 선택하세요"
                />
                <Input
                  type="text"
                  placeholder="계좌번호를 입력해주세요"
                  name="businessAccountNumber"
                  value={formData.businessAccountNumber}
                  onChange={(e) => {
                    const formattedNumber = formatAccountNumber(e.target.value);
                    setFormData((prevData) => ({
                      ...prevData,
                      businessAccountNumber: formattedNumber,
                    }));
                  }}
                />
                {/* <Button type="button">계좌 확인</Button> */}
              </Row>
            </Section>
          </>
        ) : permissions === 'BUYER' ? (
          <>
            <Section>
              <Row>
                <Label>아이디</Label>
                <Text>{formData.identifier}</Text>
              </Row>
              <Row>
                <Label>비밀번호</Label>
                <Button type="button" onClick={handleOpenPopup}>
                  비밀번호 변경
                </Button>
              </Row>
              <Row>
                <Label>이름</Label>
                <Text>{formData.name}</Text>
              </Row>

              <Row>
                <Label>이메일주소</Label>
                <Text>{formData.email}</Text>
              </Row>

              <Row>
                <Label>전화번호</Label>
                <Input
                  type="text"
                  placeholder="전화번호를 입력해주세요"
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={(e) => {
                    const formattedNumber = formatPhoneNumber(e.target.value); // 3-4-4 포맷 적용
                    setFormData((prevData) => ({
                      ...prevData,
                      phoneNumber: formattedNumber,
                    }));
                  }}
                />
              </Row>

              <Row>
                <Label>주소</Label>
                <Input
                  type="text"
                  placeholder="주소를 입력해주세요"
                  name="defaultAddress"
                  value={formData.defaultAddress}
                  readOnly
                />
                <KakaoAddressSearch onComplete={handleAddressComplete} />
              </Row>
              <Row>
                <LabelNo />
                <Input
                  type="text"
                  placeholder="우편번호"
                  style={{ maxWidth: 100 }}
                  readOnly
                  name="zipCode"
                  value={formData.zipCode}
                />
                <Input
                  type="text"
                  placeholder="상세 주소를 입력해주세요"
                  name="detailAddress"
                  value={formData.detailAddress}
                  onChange={handleChange}
                />
              </Row>
            </Section>
          </>
        ) : (
          <div>잘못된 권한 값입니다. 페이지를 새로고침하세요.</div>
        )}
        <ButtonContainer>
          <SecessionButton
            type="button"
            onClick={() => navigate(`${MyPageUrl}?activeTab=2`)}
          >
            회원탈퇴하기
          </SecessionButton>
          <UpdateButton type="button" onClick={handleUpdateAccount}>
            회원정보 수정
          </UpdateButton>
        </ButtonContainer>
      </Box>
      {isPopupOpen && <FindPasswordPopup onClose={handleClosePopup} />}
    </Container>
  );
};

export default MyPageTab2;
